import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAppDispatch } from "../../store/hooks";
import { forgotPasswordThunk } from "../../store/features/auth/authSlice";
import classes from "./styles.module.scss";
import { InputField } from '../../components/InputField';
import { MainButton } from '../../components/MainButton';
import { showNotification } from "../../store/features/notifications/notificationSlice";

export const ForgotPasswordPage = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(forgotPasswordThunk({ email }))
      .unwrap()
      .then(() => {
        navigate("/signin");
        dispatch(showNotification({ message: "Reset email sent successfully.", type: "success" }));
      })
      .catch(() => {
        dispatch(showNotification({ message: "Failed to send reset email.", type: "error" }));
      });
  };

  return (
    <div className={classes.ForgotPasswordPage}>
      <div className={classes.contentWrapper}>
        <div className={classes.logo} onClick={() => navigate("/")} >.shortform</div>
        <div className={classes.infoWrapper}>
          <h2>Reset your password</h2>
          <div className={classes.infoText}>
            <p>Enter your email address and we'll send you a link to reset your password.</p>
          </div>
        </div>
        <div className={classes.formWrapper}>
          <InputField label='Email' role='email' value={email} onChange={(e) => setEmail(e.target.value)} onValidationError={setEmailError} />
          <MainButton title='Send reset link' variant='primary' fullWidth onClick={handleSubmit} disabled={!email || !!emailError} />
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
